import styled, { css } from "styled-components";
import { Avatar, Paper } from "@mui/material";

const ChatWindowComponentPaper = styled.div`
  overflow-y: auto;
  padding-inline: 16px;
  padding-block-start: 16px;
  box-shadow: ${(props) => props.boxShadow || "none"} !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  scrollbar-width: thin;
  background-color: #ffffff;
  max-height: ${(props) => {
    if (props.isMobile) {
      return props.chatWindowHeight === 48 ? "calc(100vh - 250px)" : "90%";
    }
    if (props.isDesktop) {
      return props.chatWindowHeight === 60 ? "70vh" : "70vh";
    }
    if (props.isIpadAirLandscape) {
        return props.chatWindowHeight === 48 ? "70vh" : "66vh";
    }
    if (props.isIpadProLandscape) {
        return props.chatWindowHeight === 48 ? "70vh" : "66vh";
    }
    if (props.isIpadAirPortrait) {
      return props.chatWindowHeight === 48 ? "74vh" : "66vh";
    }
    if (props.isIpadProPortrait) {
      return props.chatWindowHeight === 48 ? "76vh" : "66vh";
    }
    return "68vh"
  }};
`;

const ChatWindowAvatar = styled(Avatar)`
  margin-right: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const MessageContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  width: ${(props) => props.width || "70%"};
  align-items: flex-start;
  flex-direction: ${props => props.itemType === 'sent' ? 'row-reverse' : 'row'};
`;

const flexWrapperStyles = css`
  display: flex;
`;

const normalWrapperStyles = css`
  display: block;
`;

const MessageWrapper = styled.div`
  padding: 12px 16px;
  border-radius: 18px;
  max-width: 85%;
  position: relative;
  transition: all 0.2s ease;
  margin: ${props => props.itemType === 'sent' ? '0 8px 0 12px' : '0 12px 0 0'};
  min-height: 76px;
  ${props => props.itemType === 'sent' ? `
 

    background: rgba(33, 115, 255, 0.04);
    color: black;
    border-radius: 10px;
  
    
    &:hover {
      box-shadow: 0 4px 8px rgba(47, 128, 237, 0.2);
    }
  ` : `
    background: #fafafa;
    color: #333333;
    border-radius: 10px;
    
    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
  `}

  > * {
    margin: 0;
    font-size: 0.875rem;
    font-family: "Inter", sans-serif;
    line-height: 1.5;
  }

  .markdown-content, .html-content {
    width: 100%;
    overflow-x: auto;
    
    table {
      border-collapse: collapse;
      width: 100%;
      margin: 8px 0;
      border-radius: 8px;
      overflow: hidden;

      th, td {
        border: 1px solid ${props => props.theme.colors.silverGrayTwo};
        padding: 8px 12px;
        text-align: left;
      }

      th {
        background-color: #F8F9FA;
      }
    }

    pre {
      background-color: ${props => props.itemType === 'sent' ? 'rgba(255, 255, 255, 0.1)' : '#F8F9FA'};
      padding: 12px;
      border-radius: 8px;
      overflow-x: auto;
      margin: 8px 0;
    }

    code {
      background-color: ${props => props.itemType === 'sent' ? 'rgba(255, 255, 255, 0.1)' : '#F8F9FA'};
      padding: 2px 6px;
      border-radius: 4px;
      font-family: 'Fira Code', monospace;
      font-size: 0.9em;
    }

    p {
      margin: 4px 0;
    }

    ul, ol {
      margin: 8px 0;
      padding-left: 24px;
    }

    li {
      margin: 4px 0;
    }

    blockquote {
      border-left: 4px solid ${props => props.itemType === 'sent' ? 'rgba(255, 255, 255, 0.2)' : '#E0E0E0'};
      margin: 8px 0;
      padding: 4px 12px;
      color: ${props => props.itemType === 'sent' ? 'rgba(255, 255, 255, 0.9)' : '#666'};
    }
  }

      ${props => props.$flex ? flexWrapperStyles : normalWrapperStyles}

  .typing-indicator {
    display: flex;
    gap: 4px;
    padding: 8px 12px;
    background: #F0F0F0;
    border-radius: 12px;
    width: fit-content;

    span {
      width: 6px;
      height: 6px;
      background: #666;
      border-radius: 50%;
      animation: bounce 1.4s infinite ease-in-out;

      &:nth-child(1) { animation-delay: -0.32s; }
      &:nth-child(2) { animation-delay: -0.16s; }
    }
  }

  /* File attachment styles */
  .file-message {
    margin-bottom: 8px;
    font-weight: 500;
  }

  .file-attachments {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
  }

  .file-attachment {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .file-info {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .file-name {
    font-weight: 500;
    font-size: 13px;
    color: ${props => props.theme.colors.text || '#333'};
    word-break: break-all;
  }

  .file-meta {
    font-size: 11px;
    color: ${props => props.theme.colors.darkGray || '#666'};
    margin-top: 2px;
  }

  .attachment-reference {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    padding: 4px 8px;
    background: rgba(33, 115, 255, 0.1);
    border-radius: 4px;
    font-size: 12px;
    color: ${props => props.theme.colors.primary};
    
    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @keyframes bounce {
    0%, 80%, 100% { transform: translateY(0); }
    40% { transform: translateY(-4px); }
  }
`;

const MessageInfo = styled.p`
  margin: 0 0 4px 0;
  color: ${props => props.itemType === 'sent' ? 'rgba(255, 255, 255, 0.9)' : props.theme.colors.davysGrey};
  font-size: 0.8em;
`;

const MessageButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: ${props => props.mt || "20px"};
  align-items: center;

  a {
    cursor: pointer;
  }
`;

const EditMessageWrapper = styled.div`
  padding: 12px;
  border-radius: 12px;
  width: 100%;
  color: ${props => props.theme.colors.primary};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  > * {
    margin: 0;
  }
`;

const EditMessageText = styled.div`
  ${props => props.theme.fonts.variant.light};
  font-size: ${props => props.theme.fonts.size.medium};
  color: ${props => props.theme.colors.black};
  text-align: center;
`;

const EditMessageInput = styled.textarea`
  resize: none;
  padding: 5px 10px;
  border-radius: 10px;

  &:focus {
    outline: none;
  }
`;

const EditMessageInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${props => props.theme.colors.primary};
`;

const SpinnerImage = styled.img`
  height: 30px;
  margin-left: 5px;
  opacity: 0.5;
`;

export {
  ChatWindowComponentPaper,
  ChatWindowAvatar,
  MessageContainer,
  MessageWrapper,
  MessageButtonsWrapper,
  EditMessageWrapper,
  EditMessageText,
  EditMessageInput,
  EditMessageInputWrapper,
  SpinnerImage,
  MessageInfo
};